import { Box, Flex, Spinner } from '@chakra-ui/react';
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import { useState } from 'react';
import { EventContentArg } from '@fullcalendar/core';
import CalendarEvent from 'components/CalendarEvent';
import { eventsStyle } from 'theme/fullcalendar';

const events = [
    {
        id: '1',
        title: '10:00',
        date: '2024-09-27 10:00:00',
    },
    {
        id: '2',
        title: '10:20',
        date: '2024-09-27 10:20:00',
    },
    {
        id: '3',
        title: '10:40',
        date: '2024-09-27 10:40:00',
    },
    {
        id: '4',
        title: '11:00',
        date: '2024-09-27 11:00:00',
    },
]

const renderEventContent = (eventInfo: EventContentArg) => {
    return <CalendarEvent label={`${eventInfo.event._def.title}`} />
};

const WeekCalendar = () => {
	const [weekDate, setWeekDate] = useState(new Date())
	console.log(weekDate);
	const [isLoading, setIsLoading] = useState(false)

	const mockFetch = () => {
		//setIsLoading(true);
		setTimeout(() => {
			setIsLoading(false);
			console.log('kei kei jei')
		}, 2000);
	}

	const handleDatesSet = (dateInfo: any) => {
		const newWeekDate = dateInfo.start; // Início da semana atual no calendário
		setWeekDate(newWeekDate)
		console.log(newWeekDate);
		//mockFetch();
	};

	if (isLoading) return (
		<Flex w="full" h="100px" justifyContent="center" alignItems="center">
			<Spinner size="lg" />
		</Flex >
	)

	return (
		<Box w="full" maxH="180px" overflowY="auto" className="customScrollbar">
			<FullCalendar
                locale="pt-br"
				plugins={[timeGridPlugin, dayGridPlugin]}
				initialView="dayGridWeek"
				events={events}
				datesSet={handleDatesSet}
                eventContent={renderEventContent}
				headerToolbar={{
					left: 'title',
					center: '',
					right: 'prev,next',
				}}
                {...eventsStyle}
			/>
		</Box>
	)
}

export default WeekCalendar
